module.exports = __webpack_public_path__ + "static/media/smile-sad.dd3f315a.png";